import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardRoutes } from '../dashboard/dashboard.routing';
import { AutenticacaoService } from '../services/autenticacao.service';
import { CarregandoService } from '../services/carregando.service';
import { FuncionarioService } from '../services/funcionario.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';

@Component({
  selector: 'app-proibido',
  templateUrl: './proibido.component.html',
  styleUrls: ['./proibido.component.scss'],
})
export class ProibidoComponent implements OnInit {
  permissao: any;

  constructor(
    private globalService: GlobalService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private funcionarioService: FuncionarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
  ) {
    if (this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.permissao) {
      this.permissao = this.router.getCurrentNavigation().extras.state.permissao;
    }
  }

  ngOnInit() {}
}
